<template>
  <div class="fillSpace" @mouseover="startSelection()" @mouseleave="stopSelection()">
    <!-- main pane content -->
    <div class="element" style="height: 100%" v-show="!selecting">
      <!-- title, image, button -->
      <div v-bind:class="beforeSelect ? 'beforeSelect' : 'afterSelect'">
        <img
          v-bind:style="{ 'margin-top': this.verticalAdjust + 'px' }"
          class="vertical-adjustment"
          :width="beforeSelect ? 64 : 48"
          :src="imagePath"
        />
        <p>{{ title.toUpperCase() }}</p>
        <!-- <button class="videoselection" @click="startSelection()">{{title}}</button> -->
      </div>
    </div>
    <!-- only appears when selecting -->
    <div class="videos" v-bind:class="{ open: selecting }" v-show="selecting">
      <a
        class="productButton"
        href="javascript:void(0)"
        @click="go(link.description)"
        v-for="link in links"
        v-bind:key="link.id"
        :value="link.description"
      >
        <img width="20" height="20" src="../../assets/ic-play.svg" />
        <span class="video-label">{{ link.description }}</span>
      </a>
    </div>
    <!-- only appears when selecting -->
    <div class="products" v-show="!selecting">
      <button class="productButton" @click="startSelection($event)">
        <span class="label">
          {{ links.length > 1 ? `${links.length} vidéos` : `${links.length} vidéo` }}
        </span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: ['title', 'subtitle', 'category', 'image', 'links', 'verticalAdjust'],

  computed: {
    imagePath() {
      return require(`../../assets/${this.image}`);
    },
  },
  data() {
    return {
      beforeSelect: true,
      selecting: false, // during select
      selected: {
        name: this.subtitle,
        id: false,
      },
      videos: { length: 10 },
    };
  },
  methods: {
    // on click on selection button
    startSelection() {
      this.selecting = true;
      this.$parent.$emit('setHeight', '130'); // this will make the Pane bigger
    },
    stopSelection() {
      this.beforeSelect = true;
      this.selecting = false; // during select
      this.selected = {
        name: this.subtitle,
        id: false,
      }; // after select contains the product
      this.$parent.$emit('setHeight', '100'); // this will make the Pane bigger
    },
    go(videoName) {
      this.$router.push(`/player/${this.category}/${videoName}`).catch(err => {
        this.$log.error(err);
      });
    },
  },
};
</script>

<style scoped>
.fillSpace {
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
  width: 90%;
  align-items: center;
  justify-content: center;
  overflow-x: hidden;
  overflow-y: auto;
}

.beforeSelect {
  width: 100%;
  margin-top: 80px;
}

button {
  border: none;
  background-color: white;
}

.videoselection {
  font-size: 1.2em;
  width: 100%;
}
.beforeSelect p {
  font-size: 32px;
  margin: auto;
  padding-top: 6vh;
  vertical-align: middle;
}
.beforeSelect .videos {
  display: block;
  border-top: 1px solid lightgray;
  /* bottom: 9px; */
  height: 88px;
  width: 70%;
  font-size: 18px;
  margin: auto;
  /* margin-bottom: 10px; */
}

.productButton .label {
  font-family: AkhandSoft;
  font-size: 18px;
}
.element {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: anim-opacity 500ms forwards;
  animation-timing-function: ease-out;
}
.products {
  display: flex;
  border-top: 1px solid lightgray;
  /* bottom: 9px; */
  height: 88px;
  width: 70%;
  font-size: 18px;
  margin: auto;
  /* margin-bottom: 10px; */
}

.beforeSelect p {
  top: 35%;
  position: absolute;
  left: 0px;
  right: 0px;
}

.videos {
  width: 100%;
}
.videos.open {
  animation: anim-overflow 1500ms forwards;
  animation-timing-function: ease-out;
}

.productButton {
  width: auto;
  font-family: AkhandSoft;
  font-weight: 300;
  font-size: 20px;
  display: flex;
  margin: auto;
  padding: 0 8%;
  text-align: left;
  text-decoration: none;
  color: #5e6a71;
  cursor: pointer;
  background-color: transparent;
  min-height: 6vh;
  align-items: center;
}
.productButton:hover {
  color: black;
}

.productButton .video-label {
  position: relative;
  display: inline-block;
}
.productButton:hover .video-label:after {
  content: '';
  position: absolute;
  display: block;

  padding-top: 4px;
  width: 65px;

  text-align: center;
  border-bottom: 2px solid #0088ec;
}

.videos .productButton {
  margin: 0;
  padding-top: 14px;
}

.productButton img {
  margin-right: 10px;
  margin-top: 4px;
}

/*
résolution moins de 1024
*/
@media (max-width: 1024px) {
  .beforeSelect {
    font-size: 22px;
    margin-top: 30px;
  }
  .beforeSelect p {
    font-size: 22px;
    margin: auto;
    padding-top: 40px;
    vertical-align: middle;
  }
}
</style>
